module.exports = __webpack_public_path__ + "static/media/ooc_no_zoom.7bdcc038.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ooc_no_zoom.png
// module id = 94
// module chunks = 0